import { render } from "./AboutUs.vue?vue&type=template&id=5edbb58a&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"

import "./AboutUs.vue?vue&type=style&index=0&id=5edbb58a&lang=less&scoped=true"

import exportComponent from "C:\\project\\结构计算网\\famous-build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5edbb58a"]])

export default __exports__